import script from "./LocationsPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocationsPagination.vue?vue&type=script&lang=ts&setup=true"

import "./LocationsPagination.vue?vue&type=style&index=0&id=9ff36db4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ff36db4"]])

export default __exports__